import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { Section } from '@/entities/section';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import { calculateConfiguratorWidth, calculateRackDepth } from '@/shared/lib/configurator';
import { EditorSide } from '@/shared/types/configurator';
import { CSSProperties } from 'react';
import { calculateSectionLeftPositions } from '../../lib/styles';
import styles from './top-editor-sections.module.css';
import { TopEditorSectionsProps } from './top-editor-sections.props';

export const TopEditorSections = ({ side }: TopEditorSectionsProps) => {
	const {
		state: { sections, wallMounted },
	} = useConfigurator();

	const width = calculateConfiguratorWidth(sections, wallMounted);
	const rackDepth = calculateRackDepth(sections);

	const leftPositions = calculateSectionLeftPositions(sections, wallMounted);

	const getSectionStyles = (index: number) => {
		const styles: CSSProperties = {
			left: leftPositions[index],
		};

		if (side === 'bottom') {
			styles.top = 0;
		} else {
			styles.bottom = 0;
		}

		return styles;
	};

	return (
		<div
			style={{ width: width * DISPLAY_SCALE, height: rackDepth * DISPLAY_SCALE }}
			className={styles.sections}
		>
			{sections.map((section, index) => (
				<Section
					side={EditorSide.TOP}
					section={section}
					sectionIndex={index}
					key={index}
					className={styles.section}
					style={getSectionStyles(index)}
				/>
			))}
		</div>
	);
};
